import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from "moment";
import { stripHtmlTags } from "@Shared/utils/utils";
import { DATE_FORMAT } from "@Shared/utils/constants";
import { reminderClassificationStatusMap } from "@Shared/@Utils/vue/filters/reminders-filters";
const DATE_TIME_FORMAT = "YYYY-MM-DD HH:mm:ss";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "UpcomingActivity",
  props: {
    id: {
      type: String,
      required: true
    },
    complete: {
      type: Boolean,
      default: false
    },
    description: {
      type: String,
      default: ""
    },
    scheduledDate: {
      type: String,
      default: ""
    },
    scheduledTime: {
      type: String,
      default: ""
    },
    clientProfileId: {
      type: [String, Number],
      required: true
    },
    boardId: {
      type: [String, Number],
      required: true
    },
    read: {
      type: Boolean,
      required: true
    },
    givenName: {
      type: String,
      default: ""
    },
    familyName: {
      type: String,
      default: ""
    }
  },
  computed: {
    strippedDescription() {
      return stripHtmlTags(this.description);
    },
    scheduledDateTime() {
      return `${this.scheduledDate} ${this.scheduledTime}`;
    }
  },
  methods: {
    handleChange(event, id) {
      const complete = event.currentTarget.checked;
      this.$emit("activity-change", {
        complete,
        id
      });
    },
    getFormatClass() {
      const hoursDiff = this.hoursDiff();
      const activityState = this.activityStateParser(hoursDiff);
      return reminderClassificationStatusMap[activityState].cssClass;
    },
    formatTimeAgo() {
      const hoursDiff = this.hoursDiff();
      const _moment = moment(this.scheduledDateTime, DATE_TIME_FORMAT);
      const timeAgo = _moment.fromNow(true);
      const activityState = this.activityStateParser(hoursDiff);
      return reminderClassificationStatusMap[activityState].text(timeAgo);
    },
    gotToAnchor(clientProfileId, boardId) {
      this.$router.replace({
        name: "client-profile",
        params: {
          clientProfileId,
          boardId
        }
      });
      this.closePopover();
    },
    hoursDiff() {
      return moment(this.scheduledDateTime, DATE_TIME_FORMAT).diff(moment().format(DATE_FORMAT), "hours");
    },
    activityStateParser(hoursDiff) {
      if (hoursDiff < 0) {
        return "past-due";
      } else if (hoursDiff <= 24) {
        return "active";
      } else if (hoursDiff <= 14 * 24) {
        return "upcoming";
      } else {
        return "planned";
      }
    },
    closePopover() {
      //eslint-disable-next-line vue/custom-event-name-casing
      this.$root.$emit("popover:close");
    },
    fullName() {
      var _context;
      return _trimInstanceProperty(_context = `${this.givenName || ""} ${this.familyName || ""}`).call(_context);
    }
  }
});